import { useEffect } from 'react';
import { useTheme, useLanguage, useIframeResize } from '@/common/hooks';
import { NewTranslationsContext } from '@/common/translations';
import { getUrlParam } from '@/common/utils';
import { T, UrlParams } from '@/common/enums';

import { MiniStatsUrlParams, StatsTypes } from '../../constants';
import { MINI_TRACKING_CONFIG, TrackingProvider } from '../../tracking';

import Overview from './widgets/Overview';
import PreviousMeetings from './widgets/PreviousMeetings';
import VictoryProbability from './widgets/VictoryProbability';
import LastFiveGames from './widgets/LastFiveGames';
import TopScorers from './widgets/TopScorers';
import SeasonStats from './widgets/SeasonStats';
import Goals from './widgets/Goals';
import OverGoals from './widgets/OverGoals';
import Shots from './widgets/Shots';
import AverageMatchStats from './widgets/AverageMatchStats';
import VenueReferee from './widgets/VenueReferee';
import LeagueTable from './widgets/LeagueTable';
import PlayerStats from './widgets/PlayerStats';
import Lineup from './widgets/Lineup';

const MiniStatsWidget = () => {
  const { theme, toggleTheme } = useTheme();
  const themeURL = getUrlParam(UrlParams.THEME);
  const { containerRef } = useIframeResize('mini_stats_widget_iframe_height');

  const locale = useLanguage();

  const themeClass = theme === T.DARK ? T.DARK : '';

  useEffect(() => {
    if (themeURL) {
      toggleTheme(themeURL);
    }
  }, [themeURL, toggleTheme]);

  const renderContent = () => {
    const contentType = (getUrlParam(MiniStatsUrlParams.TYPE) || '').toLocaleLowerCase();

    switch (contentType) {
      case StatsTypes.OVERVIEW:
        return <Overview />;
      case StatsTypes.PREVIOUS_MEETINGS:
        return <PreviousMeetings />;
      case StatsTypes.VICTORY_PROBABILITY:
        return <VictoryProbability />;
      case StatsTypes.LAST_5_GAMES:
        return <LastFiveGames />;
      case StatsTypes.TOP_SCORERS:
        return <TopScorers />;
      case StatsTypes.SEASON_STATS:
        return <SeasonStats />;
      case StatsTypes.GOALS:
        return <Goals />;
      case StatsTypes.OVER_GOALS:
        return <OverGoals />;
      case StatsTypes.SHOTS:
        return <Shots />;
      case StatsTypes.AVERAGE_MATCH_STATS:
        return <AverageMatchStats />;
      case StatsTypes.VENUE_REFEREE:
        return <VenueReferee />;
      case StatsTypes.LEAGUE_TABLE:
        return <LeagueTable />;
      case StatsTypes.PLAYER_STATS:
        return <PlayerStats />;
      case StatsTypes.LINEUP:
        return <Lineup />;
      default:
        return null;
    }
  };

  return (
    <TrackingProvider value={MINI_TRACKING_CONFIG}>
      <NewTranslationsContext.Provider value={{ locale }}>
        <div ref={containerRef} className={`${themeClass} w-full`}>
          {renderContent()}
        </div>
      </NewTranslationsContext.Provider>
    </TrackingProvider>
  );
};

export default MiniStatsWidget;
